import React, { useEffect, useState } from 'react'
import { fmt } from '../api.js'
import NoteDrawer from '../components/NoteDrawer.jsx'
import { CompanyPicker, costGet, useCompany, useMeta } from './CostCommon.jsx'

// 원가관리 · 결산분개. 금액은 제조원가 명세 합계와 연동되고, 대변은 원장과 자동 대사한다.

export default function CostJournal({ month, onMonthChange, currentUserId, autoOpenNoteId, onAutoOpened }) {
  const [company, setCompany] = useCompany()
  const [meta] = useMeta()
  const [data, setData] = useState(null)
  const [err, setErr] = useState('')

  useEffect(() => {
    setErr(''); setData(null)
    costGet('/journal', { month, company }).then(setData).catch((e) => setErr(e.message))
  }, [month, company])

  return (
    <>
      <div style={{ position: 'relative' }}>
        <h2>{month} 결산분개 — 제조원가 대체</h2>
        <NoteDrawer target="journal" screenKey="cost_journal"
          context={{ month }} contextLabel={month}
          onNavigate={(ctx) => ctx?.month && onMonthChange?.(ctx.month)}
          autoOpenNoteId={autoOpenNoteId} onAutoOpened={onAutoOpened}
          currentUserId={currentUserId} />
      </div>
      <div className="row" style={{ marginBottom: 12 }}>
        <CompanyPicker value={company} onChange={setCompany} meta={meta} />
      </div>
      {err && <div className="error-box">{err}</div>}
      {!data && !err && <div className="muted">불러오는 중…</div>}
      {data && (
        <>
          <div className="hint">
            금액은 제조원가명세서 합계와 연동됩니다. 각 대변 계정은 계정별원장 금액과 자동 대사되며, 차이가 1원 이상이면 ⚠로 표시됩니다.
            계정코드가 <b>(미지정)</b>인 항목은 배부기준 화면의 &lsquo;원가 항목·계정코드 설정&rsquo;에서 코드를 넣어주세요.
          </div>
          {data.entries.map((e) => (
            <div className="panel" key={e.no}>
              <h3>전표 {e.no} — {e.description}</h3>
              <table>
                <thead>
                  <tr><th>구분</th><th>계정코드</th><th className="l">계정과목</th><th>차변</th><th>대변</th><th>원장 금액</th><th>차이</th><th>판정</th></tr>
                </thead>
                <tbody>
                  {e.debit.map((d) => (
                    <tr key={`d${d.account_code}`}>
                      <td className="c">결차</td>
                      <td className="c">{d.account_code}</td>
                      <td className="l">{d.account_name}</td>
                      <td>{fmt(d.amount)}</td>
                      <td /><td /><td /><td />
                    </tr>
                  ))}
                  {e.credit.map((c) => (
                    <tr key={`c${c.account_code}${c.account_name}`}>
                      <td className="c">결대</td>
                      <td className="c">{c.account_code}</td>
                      <td className="l">{c.account_name}</td>
                      <td />
                      <td>{fmt(c.amount)}</td>
                      <td>{c.ledger !== undefined ? fmt(c.ledger) : ''}</td>
                      <td>{c.diff !== undefined ? fmt(c.diff, 2) : ''}</td>
                      <td className="c">
                        {c.ok === undefined ? '' : c.ok ? <span className="ok">✓</span> : <span className="warn">⚠</span>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
          <div className="panel">
            <b>당월 제조원가 대체 총액: {fmt(data.grandTotal)}원</b>
          </div>
        </>
      )}
    </>
  )
}
